<template>
  <div class="">
    <top-header
      :type="6"
      :placeholder="'涉企房源出售列表'"
      :hasBorder="true"
      :bgColor="'#fff'"
      fontSize="0.32rem"
    />
    <div class="list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="">
          </div>
          <div class="m_flex_box flex_vc flex_jz inner" v-for="(item, index) in list" :key="index" @click="toDetail(item.listedId)"  >
            <img class="banner" v-lazy="imgPath + 'sClf/' + item.fmt + '.jpg'">
            <div class="right">
              <h4 class="line_comp2">{{item.xmmc}}</h4>
              <p>{{item.xzqh}}</p>
              <div class="m_flex_box flex_vb">
                <h3 class="">{{item.listedPrice ? item.listedPrice/10000 : '暂无'}}<span>万</span></h3>
                <p>{{item.zmjCount}}m²</p>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <slide-img></slide-img>
  </div>
</template>

<script>
import qs from 'qs'
import topHeader from '@/components/header'
import slideImg from '@/components/slideImg'
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      listPage: 1,
      loading: false,
      finished: false,
      timer: null,
    };
  },
  components: {
    topHeader,
    slideImg
  },
  mounted() {
  },
  methods: {
    toDetail(listedId) {
      this.$router.push({
        path: '/aboutBusinessDetail',
        query: {listedId}
      })
    },

    onRefresh() {
      this.finished = false;
      this.isLoading = false;
      this.$set(this, "list", []);
      this.$set(this, "listPage", 1);
      this.onLoad(1);
    },

    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        this.$http({
          url: "cms/companyHouseListed/permit/getCompanyHouseList.do",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data: {
            xzqh: this.main.getHostArea(),
            pageSize: 10,
            offset: (this.listPage - 1) * 10,
          },
        }).then((res) => {
          if (type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.list = this.list.concat(res.obj.rows);
            this.loading = false;
            this.listPage += 1;
          } else {
            this.finished = true;
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
  .list{
    padding: 0 0.25rem;
    min-height: 80vh;
    .inner{
      padding: 0.4rem 0;
      border-bottom: 1px solid #f5f5f5;
      img{
        width: 2.28rem;
        height: 1.72rem;
        margin-right: 0.25rem;
      }
      .right {
        width: 4.42rem;
        h4{
          font-size: 0.32rem;
          font-weight: 800;
          margin-bottom: 0.1rem;
        }
        p{
          font-size: 0.24rem;
          color: #505050;
        }
        div{
          margin-top: 0.1rem;
          h3{
            font-size: 0.4rem;
            color: #FF3520;
            font-weight: 800;
            margin-right: 0.34rem;
          }
          p{
            position: relative;
            top: -0.06rem;
          }
        }
      }
    }
  }
</style>